"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeInvoiceStatus = changeInvoiceStatus;
exports.createOrUpdateInvoiceRecord = createOrUpdateInvoiceRecord;
exports.deleteInvoiceRecord = deleteInvoiceRecord;
exports.getInvoiceRecordDetail = getInvoiceRecordDetail;
exports.getInvoiceRecordPage = getInvoiceRecordPage;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 获取发票记录分页列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
function getInvoiceRecordPage(data) {
  return (0, _request.default)({
    url: '/admin/platform/invoiceRecord/page',
    method: 'post',
    data: data
  });
}

/**
 * 获取发票记录详情
 * @param {number} id 发票记录ID
 * @returns {Promise}
 */
function getInvoiceRecordDetail(id) {
  return (0, _request.default)({
    url: "/admin/platform/invoiceRecord/detail/".concat(id),
    method: 'post'
  });
}

/**
 * 创建或更新发票记录
 * @param {Object} data 发票数据
 * @returns {Promise}
 */
function createOrUpdateInvoiceRecord(data) {
  return (0, _request.default)({
    url: '/admin/platform/invoiceRecord/createOrUpdate',
    method: 'post',
    data: data
  });
}

/**
 * 删除发票记录
 * @param {number} id 发票记录ID
 * @returns {Promise}
 */
function deleteInvoiceRecord(id) {
  return (0, _request.default)({
    url: "/admin/pay/invoice/delete/".concat(id),
    method: 'delete'
  });
}

/**
 * 修改发票状态
 * @param {Object} data { id, status }
 * @returns {Promise}
 */
function changeInvoiceStatus(data) {
  return (0, _request.default)({
    url: '/admin/platform/invoiceRecord/changeInvoiceStatus',
    method: 'post',
    data: data
  });
}